// ========================================================
// Dependencies
// ========================================================
// @import '~@Green-Dot-Corporation/eureka-lib-style-utils/src/styles/mixins/layout.scss';

.eureka-loading-state, %eureka-loading-state {
    .eureka-callout__icon {
        font-size: inherit;
    }
}
